import { Fetcher } from '@this/src/util';
import React, { useCallback } from 'react';

import User, { convertUserResponseToArgs, type UserResponseArgs } from '@this/domain/user/user2';

import _ from 'lodash';
import { AutocompleteSelect } from '@this/shared/ui/inputs/autocomplete';

type Props = {
  user?: User;
  traveler: User | undefined;
  index: number;
  onSelect: (i: number, traveler: User, type: string) => void;
  excludeUserIds?: number[];
};

type MembersListResponse = {
  members: UserResponseArgs[];
};

const SelectTravelersBlock = ({ user, traveler, index, onSelect, excludeUserIds = [] }: Props) => {
  const getOptions = useCallback(
    async (keyword?: string) => {
      try {
        const res = await Fetcher.get<MembersListResponse>('/members.json', { keyword });
        const allUsers = [user, ...res.members.map(m => new User(convertUserResponseToArgs(m)))];
        return _.unionBy(allUsers, u => u?.id).filter(u => !excludeUserIds.find(id => id === u?.id));
      } catch (e) {
        return [];
      }
    },
    [user, excludeUserIds]
  );

  const handleOnChange = useCallback(
    (selected: User | null) => {
      if (!selected) {
        return;
      }

      const newType = selected.id === user?.id ? 'self' : 'member';
      onSelect(index, selected, newType);
    },
    [user, onSelect, index]
  );

  return (
    <AutocompleteSelect
      async="FILTERING"
      placeholder="-- クリックしてメール通知者を選択ください --"
      getOptions={getOptions}
      value={traveler}
      getOptionLabel={u => u?.emailAndName || ''}
      onChange={(_e, selected) => handleOnChange(selected)}
      disableClearable
    />
  );
};

export default SelectTravelersBlock;
